export function getCurrent() {
  return "/secure/current";
}

export function getCorpList() {
  return "/api/system/corporates/tree";
}

export function getDepartList(corpId) {
  return `/api/system/departments/tree/${corpId}/corp`;
}

export function getUserList(corpId, departId) {
  return `/api/system/user/corporates/${corpId}/departments/${departId}`;
}

export function getUserListByIds() {
  return "/api/system/users/userIds/list";
}

export function getRecentUserList() {
  return `/api/system/users/latest-select`;
}

export function addRecentUserList() {
  return `/api/system/users/latest-select`;
}

export function getManagerList() {
  return "/type-api/system/manager/all";
}

/*去除左右空格*/
export const trim = (s) => {
  return s.replace(/(^\s*)|(\s*$)/g, "");
};

/*获取组织树*/
export function getOrgList() {
  return "/api/system/organization/tree";
}

/*获取任意部门或单位的用户信息列表（人员搜索框）*/
export function systemSearchUser() {
  return "/api/system/search/user";
}

/*获取当前用户 用户组数组 */
export function getUserGroupList(ownerId) {
  return `/api/system/user/${ownerId}/custom-user-groups`;
}
/* update用户组数组 */
export function updateUserGroupList(ownerId) {
  return `/api/system/user/${ownerId}/custom-user-groups`;
}
/* delete用户组数组 */
export function deleteGroupList(ownerId, groupId) {
  return `/api/system/user/${ownerId}/group-id/${groupId}/custom-user-group`;
}
